import React, { Fragment, useState, useEffect, useRef, useContext, useCallback } from "react";
import UserService from "../../../services/UserService";
import StoryService from "../../../services/StoryService";
import { useTranslation } from "react-i18next";
import Image from "react-bootstrap/Image";
import { toast } from "react-toastify";
import {
  AWS_URL,
  REDUX_LOCAL_STORE_KEY,
} from "../../../components/config/constants";
import Stories from "react-insta-stories";
import Loader from "../../../components/Loader.jsx";
import { Link } from "react-router-dom";
import { X, Eye, VolumeX, Volume2, MoreHorizontal, AlertCircle, DollarSign, Heart, MessageCircle, Trash2, ThumbsUp } from "lucide-react";
import TipModal from "../Tip/TipModal";
import { SocketContext } from "../../../context/SocketContext";
import ReportModal from "../../../components/common/commonModal/ReportModal.jsx";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { getUserProfilePic } from "../../../components/helper/GeneralHelper";
import DefaultAvatar from "../../../components/common/DefaultAvatar.jsx";
import AccountVerifyTick from "../../../components/common/AccountVerifyTick.jsx";
import { MultiNumber } from "../../../components/common/MultiNumber.jsx";
import { useHistory, useParams } from "react-router-dom";

const CreatorStories = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id: paramId } = useParams();
  const socketContext = useContext(SocketContext);

  const clickSendMessage = useRef(null);
  const width = window.innerWidth;
  const isMobile = width <= 512;

  const [state, setState] = useState({
    arrayStoryUrl: [],
    storyList: [],
    currentStory: 0,
    isStoryMuted: false,
    showOption: false,
    showModalTip: false,
    showModalReport: false,
    loading: true,
    creatorId: null,
    isMe: false,
    showModalDelete: false,
    messageValue: "",
    creatorUserName: "",
    storyLikeList: [],
    showModalStatistics: false,
    storyId: null,
    doMessage: false,
  });

  const getStoryList = useCallback((creatorId, isMe) => {
    if (state.storyId) {
      StoryService.getStoryById(state.storyId).then(() => {});
    } else {
      if (!isMe) {
        let params = {
          creatorId: creatorId,
        };
        UserService.storiesCreator({ ...params })
          .then((res) => {
            const arrayStoryUrl = res.data.data.map((value) => ({
              url: value.storyMedia.storyUrl,
              type: value.storyMedia.type,
              id: value._id,
              liked: value.userStoryDetails[0]?.liked
                ? value.userStoryDetails[0]?.liked
                : false,
              creatorDetails: value.creatorDetails,
            }));
            setState((prev) => ({ ...prev, arrayStoryUrl: arrayStoryUrl, loading: false }));
          })
          .catch((err) => {
            history.push("/page-not-found");
          });
      } else {
        StoryService.myStories()
          .then((res) => {
            const arrayStoryUrl = res.data.data.map((value) => ({
              url: value.storyMedia.storyUrl,
              type: value.storyMedia.type,
              id: value._id,
              liked: value.userStoryDetails[0]?.liked
                ? value.userStoryDetails[0]?.liked
                : false,
              creatorDetails: value.creatorDetails,
            }));
            setState((prev) => ({ ...prev, arrayStoryUrl: arrayStoryUrl, loading: false }));
          })
          .catch((err) => {
            history.push("/page-not-found");
          });
      }
    }
  }, [history, state.storyId]);

  useEffect(() => {
    const me = JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
      .authentication.userData._id;
    const isMe = paramId === me;

    setState((prev) => ({
      ...prev,
      creatorId: paramId,
      isMe: isMe,
    }));

    getStoryList(paramId, isMe);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getStoryLike = useCallback((storyId) => {
    let params = {
      storyId: storyId,
      page: 0,
      limit: 250,
    };
    StoryService.getStoryLike({ ...params })
      .then((res) =>
        setState((prev) => ({
          ...prev,
          storyLikeList: res.data.data[0].data,
          showModalStatistics: true,
        }))
      )
      .catch(() => {});
  }, []);

  const scrollNext = useCallback(() => {
    history.goBack();
  }, [history]);

  const muteAllVideos = useCallback((muted) => {
    const videoElements = document.getElementsByTagName("video");
    for (let i = 0; i < videoElements.length; i++) {
      videoElements[i].muted = muted;
    }
  }, []);

  const muteStory = useCallback(() => {
    setState((prev) => {
      const newMuted = !prev.isStoryMuted;
      setTimeout(() => muteAllVideos(newMuted), 0);
      return { ...prev, isStoryMuted: newMuted };
    });
  }, [muteAllVideos]);

  const sendMessage = useCallback(() => {
    let params = {
      senderId: JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
        .authentication.userData._id,
      receiverId: state.creatorId,
      message: {
        text: state.messageValue,
        messagePrice: null,
      },
    };
    socketContext?.socket?.emit("add_message", params);
    setState((prev) => ({ ...prev, messageValue: "" }));
  }, [state.creatorId, state.messageValue, socketContext]);

  const visualizeStory = useCallback((currentStory, arrayStoryUrl) => {
    let params = {
      storyId:
        arrayStoryUrl[
          currentStory - (currentStory > 0 ? 1 : 0)
        ]?.id,
    };
    StoryService.visualizeStory({ ...params })
      .then(() => {})
      .catch((err) => toast.error(err.message));
  }, []);

  const likeOrDislike = useCallback(() => {
    let params = {
      storyId: state.arrayStoryUrl[state.currentStory]?.id,
    };
    StoryService.likeStory({ ...params })
      .then(() => {
        setState((prev) => {
          let arrayStoryUrl = [...prev.arrayStoryUrl];
          arrayStoryUrl[prev.currentStory] = {
            ...arrayStoryUrl[prev.currentStory],
            liked: arrayStoryUrl[prev.currentStory].liked
              ? !arrayStoryUrl[prev.currentStory].liked
              : true,
          };
          return { ...prev, arrayStoryUrl };
        });
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [state.arrayStoryUrl, state.currentStory]);

  const deleteStory = useCallback((storyId) => {
    let params = {
      storyId: storyId,
    };
    StoryService.deleteStorie({ ...params })
      .then(() => {
        history.push("/");
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [history]);

  return (
    <Fragment>
      <div
        onClick={() => {
          if (state.showOption === true) {
            setState((prev) => ({ ...prev, showOption: false }));
          }
        }}
        className="stories-page-single"
      >
        {state.loading ? (
          <Loader />
        ) : (
          <>
            {state.arrayStoryUrl[state.currentStory] !==
              undefined && (
              <div className="story-card-current hover flex-paginator">
                <span className="story-style">
                  <span
                    style={{ position: "absolute" }}
                    className="story-creator-icon"
                  >
                    <div className="flex-paginator fix-story-icon">
                      <DefaultAvatar
                        id={state.creatorId}
                        userName={
                          state.arrayStoryUrl[state.currentStory]
                            .creatorDetails?.name
                        }
                        width={"32px"}
                        height={"32px"}
                        className="picture-story"
                      >
                        {state.arrayStoryUrl[state.currentStory]
                          .creatorDetails?.profilePicture ? (
                          <Image
                            className="picture-story"
                            style={{ borderRadius: "99px" }}
                            width={32}
                            height={32}
                            alt={
                              state.arrayStoryUrl[
                                state.currentStory
                              ].creatorDetails?.name
                            }
                            title={
                              state.arrayStoryUrl[
                                state.currentStory
                              ].creatorDetails?.name
                            }
                            src={getUserProfilePic(
                              state.creatorId,
                              state.arrayStoryUrl[
                                state.currentStory
                              ].creatorDetails?.profilePicture
                            )}
                          ></Image>
                        ) : null}
                      </DefaultAvatar>
                      <span className="story-creators-name">
                        {
                          state.arrayStoryUrl[state.currentStory]
                            .creatorDetails?.name
                        }
                        {state.arrayStoryUrl[state.currentStory]
                          .creatorDetails?.isCreatorVerified ? (
                          <span
                            style={{
                              marginLeft: "2px",
                              verticalAlign: "text-bottom",
                            }}
                          >
                            <AccountVerifyTick width="15px"></AccountVerifyTick>
                          </span>
                        ) : null}
                      </span>
                    </div>
                  </span>
                  <span className="remove-option-image-iphone-chrome">
                    <Stories
                      stories={state.arrayStoryUrl}
                      defaultInterval={15000}
                      width={
                        isMobile
                          ? "100vw"
                          : "calc(86.6666666vh * 0.560897)"
                      }
                      height={isMobile ? "100vh" : "86.6666666vh"}
                      isPaused={
                        state.showModalTip ||
                        state.showModalReport ||
                        state.showModalDelete
                      }
                      loop={false}
                      onAllStoriesEnd={scrollNext}
                      loader={<Loader />}
                      muted={state.isStoryMuted}
                      onStoryEnd={() =>
                        setState((prev) => {
                          const newCurrentStory = prev.currentStory + 1;
                          setTimeout(() => visualizeStory(newCurrentStory, prev.arrayStoryUrl), 0);
                          return { ...prev, currentStory: newCurrentStory };
                        })
                      }
                      onNext={() =>
                        setState((prev) => {
                          const newCurrentStory = prev.currentStory + 1;
                          setTimeout(() => visualizeStory(newCurrentStory, prev.arrayStoryUrl), 0);
                          return { ...prev, currentStory: newCurrentStory };
                        })
                      }
                      onPrevious={() =>
                        setState((prev) => ({
                          ...prev,
                          currentStory:
                            prev.currentStory -
                            (prev.currentStory > 0 ? 1 : 0),
                        }))
                      }
                    />
                  </span>
                </span>
                <span
                  onClick={() =>
                    setState((prev) => ({ ...prev, showOption: !prev.showOption }))
                  }
                  className="story-option-button"
                >
                  <MoreHorizontal size={20} />
                  {state.showOption && (
                    <div className="option-story-div">
                      {state.creatorId !==
                        JSON.parse(
                          localStorage.getItem(REDUX_LOCAL_STORE_KEY)
                        ).authentication.userData._id && (
                        <div
                          className="d-flex justify-content-start align-items-center"
                          onClick={() =>
                            setState((prev) => ({ ...prev, showModalReport: true }))
                          }
                        >
                          <AlertCircle
                            size={18}
                            style={{ position: "relative" }}
                          />{" "}
                          {t("stories.report")}
                        </div>
                      )}
                      {state.creatorId !==
                        JSON.parse(
                          localStorage.getItem(REDUX_LOCAL_STORE_KEY)
                        ).authentication.userData._id && (
                        <div
                          className="d-flex justify-content-start align-items-center"
                          onClick={() =>
                            setState((prev) => ({ ...prev, showModalTip: true }))
                          }
                        >
                          <DollarSign
                            size={18}
                            style={{ position: "relative" }}
                          />{" "}
                          {t("stories.tip")}
                        </div>
                      )}
                      {state.creatorId ===
                        JSON.parse(
                          localStorage.getItem(REDUX_LOCAL_STORE_KEY)
                        ).authentication.userData._id && (
                        <div
                          name="no-close"
                          className="d-flex justify-content-start align-items-center"
                          onClick={() => {
                            setState((prev) => ({ ...prev, showModalDelete: true }));
                          }}
                        >
                          <Trash2
                            size={18}
                            style={{
                              position: "relative",
                            }}
                          />{" "}
                          {t("stories.delete")}
                        </div>
                      )}
                    </div>
                  )}
                </span>
                <span
                  onClick={() => muteStory()}
                  className="mute-button"
                >
                  {state.isStoryMuted === false ? (
                    <Volume2 size={20} />
                  ) : (
                    <VolumeX size={20} />
                  )}
                </span>
                {isMobile && (
                  <span
                    onClick={() => history.goBack()}
                    className="close-story-button"
                  >
                    <X size={20} style={{ color: "white" }} />
                  </span>
                )}
              </div>
            )}
            {state.isMe ? (
              <div
                onClick={() => {
                  getStoryLike(
                    state.arrayStoryUrl[state.currentStory]?.id
                  );
                }}
                className="footer-story-extra hover"
                style={{ color: "white", zIndex: 999 }}
              >
                <div
                  className="d-flex justify-content-center align-items-center text-shadow-20px-black"
                  style={{ gap: "8px" }}
                >
                  <Eye size={18} />
                  <span className="f-14px-16px">
                    {t("archive.seeStatistics")}
                  </span>
                </div>
              </div>
            ) : (
              <div className="footer-story-extra">
                <div className="footer-story">
                  <span
                    style={{ height: "35px" }}
                    className="border-message-story d-flex justify-content-center align-items-center"
                  >
                    <input
                      placeholder={t("stories.sendMessage")}
                      style={{
                        width: isMobile
                          ? window.innerWidth - 60 + "px"
                          : "280px",
                      }}
                      onKeyUp={(e) => {
                        if (e.code === "Enter") {
                          clickSendMessage.current.click();
                        }
                      }}
                      onChange={(value) =>
                        setState((prev) => ({
                          ...prev,
                          messageValue: value.target.value,
                        }))
                      }
                      className="message-story"
                      type="text"
                      value={state.messageValue}
                    ></input>
                  </span>
                  <span
                    style={{ display: "none" }}
                    onClick={() => sendMessage()}
                    ref={clickSendMessage}
                    className="footer-story-icon hover"
                  >
                    <MessageCircle
                      size={20}
                      style={{ color: "white" }}
                    />
                  </span>
                  <span
                    style={{ height: "35px" }}
                    className="footer-story-icon hover d-flex justify-content-center align-items-center"
                    onClick={() => likeOrDislike()}
                  >
                    {state?.arrayStoryUrl[state.currentStory]
                      ?.liked === true ? (
                      <Heart size={20} className="filled-heart" />
                    ) : (
                      <Heart size={20} />
                    )}
                  </span>
                </div>
              </div>
            )}
          </>
        )}

        {isMobile === false && (
          <>
            <div className="red-circle-story">
              <Link to="/" style={{ paddingLeft: "24px", gap: "7.24px" }}>
                <img
                  className="logo-red-circle"
                  src={`${AWS_URL}logo/logoRedCircle.png`}
                  alt=""
                ></img>
                <img
                  className="logo-red-circle"
                  src={`${AWS_URL}logo/${
                    localStorage.getItem("theme") === "theme-light"
                      ? "RedCircleBlack.png"
                      : "RedCircleRed.png"
                  }`}
                  alt=""
                ></img>
                {localStorage.getItem("theme") === "theme-dark"}
              </Link>
            </div>
            <div className="close-story">
              <div
                onClick={() => history.goBack()}
                style={{ justifyContent: "center", gap: "7.24px" }}
                className="hover"
              >
                <X size={20} className="close-x" />
              </div>
            </div>
          </>
        )}
      </div>
      {state.showModalTip && (
        <TipModal
          userName={state.creatorUserName}
          show={state.showModalTip}
          onHide={() => setState((prev) => ({ ...prev, showModalTip: false }))}
          id={state.creatorId}
          objId={state.currentStory}
          tipArea={"STORIES"}
        />
      )}
      <Modal
        show={state.showModalDelete}
        onHide={() => setState((prev) => ({ ...prev, showModalDelete: false }))}
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="ps-3 pt-2 pb-2">
          <span className="text-color-dark fw-700 font-xssss">
            {t("stories.delete")}
          </span>
        </Modal.Header>
        <Modal.Body
          className={`p-4 add-card-modal ${
            state.doMessage === true ? "pb-0" : ""
          }`}
        >
          <span className="text-color-dark fw-400 font-xssss">
            {t("stories.deleteDescription")}
          </span>
        </Modal.Body>
        <Modal.Footer className="d-flex p-2 justify-content-end">
          <div
            className="pointer fw-bold me-4 font-xsss text-silver"
            onClick={() => setState((prev) => ({ ...prev, showModalDelete: false }))}
          >
            {t("common.cancel")}
          </div>
          <Button
            className="fix-tip-button fw-bold me-2 rounded-pill font-xssss text-white px-3 py-2 pointer"
            onClick={() => {
              deleteStory(
                state.arrayStoryUrl[state.currentStory]?.id
              );
            }}
          >
            {t("account.deleteAccount.modal.confirm")}
          </Button>
        </Modal.Footer>
      </Modal>
      {state.showModalStatistics && (
        <Modal
          show={state.showModalStatistics}
          onHide={() => setState((prev) => ({ ...prev, showModalStatistics: false }))}
          keyboard={false}
          centered
        >
          <Modal.Header closeButton className="ps-3 pt-2 pb-2">
            <span className="text-color-dark fw-700 font-xssss">
              {t("archive.storyStatistics")}
            </span>
          </Modal.Header>
          <Modal.Body
            className={`p-4 add-card-modal stats-modal ${
              state.doMessage === true ? "pb-0" : ""
            }
                          `}
          >
            <div>
              <span className="text-12px">
                {t("archive.totalView")}:{" "}
              </span>
              <span className="select-category-clip">
                <MultiNumber
                  numberToFix={
                    state.arrayStoryUrl[state.currentStory]
                      .storyTotalLikes
                      ? state.arrayStoryUrl[state.currentStory]
                          .storyTotalLikes
                      : state.arrayStoryUrl[state.currentStory]
                          ?.totalViews
                  }
                />{" "}
                {t("archive.followers")}
              </span>
              <span className="text-12px" style={{ marginLeft: "16px" }}>
                {t("archive.totalLkes")}:{" "}
              </span>
              <span className="select-category-clip">
                <MultiNumber
                  numberToFix={
                    state.arrayStoryUrl[state.currentStory]
                      .totalViews
                      ? state.arrayStoryUrl[state.currentStory]
                          .totalViews
                      : state.arrayStoryUrl[state.currentStory]
                          ?.storyTotalLikes
                  }
                />{" "}
                {t("archive.followers")}
              </span>
            </div>

            <div className="scroll-like-story">
              {state.storyLikeList?.map((value, index) => {
                return (
                  <div key={index} className="container-user-like-story flex-paginator align-center-only">
                    <span>
                      <Image
                        style={{ borderRadius: "50px" }}
                        width={48}
                        height={48}
                        src={getUserProfilePic(
                          value.userDetails._id,
                          value.userDetails.profilePicture
                        )}
                      ></Image>
                      <span className="user-like-thumbs">
                        <ThumbsUp size={18} />
                      </span>
                    </span>
                    <span>
                      <div className="name-user-story">
                        {value.userDetails.userName}
                      </div>
                      <div className="wallet-info">
                        @{value.userDetails.name}
                      </div>
                    </span>
                  </div>
                );
              })}
            </div>
            <Modal.Footer className="d-flex p-2 justify-content-end border-0"></Modal.Footer>
          </Modal.Body>
        </Modal>
      )}
      {state.showModalReport && (
        <ReportModal
          type={3}
          reported={state.creatorId}
          id={state.storyList[state.creatorId]?.stories[0]._id}
          show={state.showModalReport}
          onHide={() => setState((prev) => ({ ...prev, showModalReport: false }))}
        />
      )}
    </Fragment>
  );
};

export default CreatorStories;
